import React from "react";
import { api } from "../api";
import { normalizeCheckout } from "../components/utils/normalizeCheckout";

export const useCheckout = () => {
  const [loading, setLoading] = React.useState(false);
  const [checkout, setCheckout] = React.useState(null);
  const [countries, setCountries] = React.useState([]);
  const [organization, setOrganization] = React.useState(null);
  const [error, setError] = React.useState(null);
  const checkoutID = () =>
    window.location.pathname.split("/").filter(i => !!i)[0];

  const getCheckout = async () => {
    try {
      setLoading(true);
      const response = await api.get(`checkout/${checkoutID()}`);
      const data = response?.data;
      const checkoutData = data?.checkout;

      setLoading(false);
      setCheckout(normalizeCheckout(checkoutData));
      setOrganization(data?.organization);
      setCountries(data?.countries);
    } catch (error) {
      console.log("Error on requesting Checkout API", error);
      setLoading(false);
      setError({ error: error.message });
    }
  };

  return {
    getCheckout,
    checkout,
    organization,
    countries,
    loading,
    error,
  };
};
